import React from 'react';

const Services = () => {
  return (
    <div className="services-details">
      <h1>Nasze Funkcje</h1>
      <p>Tutaj szczegółowe informacje o oferowanych funkcjach.</p>
    </div>
  );
};

export default Services;
